import {
  css,
  CSSObject,
  FlattenSimpleInterpolation,
} from 'styled-components/macro';

type StylesType = CSSObject | TemplateStringsArray | FlattenSimpleInterpolation;

export const hover = (styles: StylesType): FlattenSimpleInterpolation => css`
  &:not(:disabled):hover {
    ${styles}
  }
`;

export const selected = (styles: StylesType): FlattenSimpleInterpolation => css`
  &[data-selected='true'] {
    ${styles}
  }
`;

export const selectedHover = (
  styles: StylesType
): FlattenSimpleInterpolation => css`
  &[data-selected='true']:not(:disabled):hover {
    ${styles}
  }
`;

export const active = (styles: StylesType): FlattenSimpleInterpolation => css`
  &:active:not(:disabled) {
    ${styles}
  }
`;

export const focus = (color: string) => css`
  &:focus-visible {
    outline: 4px solid ${color};
  }
`;

export const counterStyles = ({
  color,
  bg,
}: {
  color?: string;
  bg?: string;
}) => css`
  ${color &&
  css`
    --counter-color: ${color};
  `};

  ${bg &&
  css`
    --counter-bg: ${bg};
  `};
`;
